import { render } from "./Licenciado.vue?vue&type=template&id=6ae39fe9&scoped=true"
import script from "./Licenciado.vue?vue&type=script&lang=js"
export * from "./Licenciado.vue?vue&type=script&lang=js"

import "./Licenciado.vue?vue&type=style&index=0&id=6ae39fe9&scoped=true&lang=css"

import exportComponent from "/home/devnote/Documentos/Features/Home Creditall/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae39fe9"]])

export default __exports__